import {detectDeviceAsync} from 'mediasoup-client'

export async function getMediasoupHandlerName() {
  let handlerName = await detectDeviceAsync();

  if (!handlerName) {
    const ua = navigator.userAgent;
    if (/Chrome\/(\d+)/.test(ua)) {
      const chromeMajor = parseInt(RegExp.$1, 10);

      if (chromeMajor >= 111) {
        handlerName = 'Chrome111';
      } else if (chromeMajor >= 74) {
        handlerName = 'Chrome74';
      } else {
        console.warn('[mediasoup] Chrome version is too old:', chromeMajor);
      }
    } else if (/Firefox\/(\d+)/.test(ua)) {
      handlerName = 'Firefox120';
    }
  }

  return handlerName;
}